import { render } from "./Health.vue?vue&type=template&id=78c5b61e&ts=true"
import script from "./Health.vue?vue&type=script&lang=ts"
export * from "./Health.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__